import { ClampToEdgeWrapping, RepeatWrapping, MirroredRepeatWrapping } from "three";
export const WRAPPINGS = [{ ClampToEdgeWrapping }, { RepeatWrapping }, { MirroredRepeatWrapping }];
